<template>
  <v-hover
    v-if="properties != null && properties.image != null"
    v-slot:default="{ hover }"
  >
    <v-card
      dark
      style="image-card"
      :elevation="hover ? 16 : 2"
      class="mx-auto clickable"
      @click.native="reDirect()"
    >
      <CImage
        :url="properties.image"
        :square="false"
        :alt="properties.title ? properties.title : 'image not found'"
        :contain="image_contained"
      >
        <div
          v-if="properties.title != null"
          class="fill-height image-content grey_1--text"
        >
          <span
            class="image-title image-text"
            :class="{ 'hover-image-title': hover }"
          >
            {{ properties.title }}
          </span>
          <span
            v-if="hover && properties.hovertitle != null"
            class="image-hover-title image-text grey_1--text"
            :class="{ 'hover-image-hover-title': hover }"
          >
            {{ properties.hovertitle }}
          </span>
        </div>
      </CImage>
    </v-card>
  </v-hover>
</template>

<script>
import CImage from "../SubComponents/Image";

export default {
  name: "ImageCard",
  components: {
    CImage
  },
  props: {
    properties: {
      type: Object,
      default: null
    },
    image_contained: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    reDirect() {
      if (this.properties && this.properties.searchRedirect) {
        console.log("Redirecting to :", this.properties.searchRedirect);
        //this.$router.push({ name: this.properties.searchRedirect });
        // this.redirect(this.properties.searchRedirect);
        this.$router.push({
          path: "search",
          query: { type: this.properties.searchRedirect }
        });
      }
    }
  }
};
</script>

<style scoped>
.image-card {
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);
  border-radius: 14px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  z-index: 9;
  text-decoration: none;
}

.image-content {
  margin: 0;
  padding: 0;
  background-image: linear-gradient(
    133.69deg,
    rgba(44, 177, 188, 0.5) -6.52%,
    rgba(134, 219, 231, 0.5) 45.74%,
    rgba(145, 234, 228, 0.5) 96.92%
  );
}

.image-title {
  display: block;
  position: absolute;
  width: 100%;
  top: 50%;
  text-align: center;
  transition: all 0.2s ease-out;
  transform: translateY(-50%);
  font-weight: 600 !important;
  font-size: 30px;
  line-height: 38px;
  text-shadow: 0px 0px 4px rgba(24, 144, 255, 0.5);
}

.hover-image-title {
  margin-top: -30px;
}

.image-hover-title {
  position: absolute;
  width: 100%;
  top: 50%;
  text-align: center;
  transition: all 0.2s ease-out;
  transform: translateY(calc(-50%));
  font-weight: 400 !important;
  font-size: 24px;
  line-height: 30px;
  text-shadow: 0px 0px 4px rgba(24, 144, 255, 0.5);
}

.hover-image-hover-title {
  margin-top: 30px;
  opacity: 1;
}
.v-card {
  transition: all 0.2s ease-out;
}
.v-card:hover {
  transform: scale(1.04);
  z-index: 97;
}
</style>
